export const getRequestDetails = (
  input: RequestInfo,
  init?: RequestInit,
): { body?: string; url: string; method: string } => {
  const isRequestObject = typeof Request !== 'undefined' && typeof input === 'object' && input instanceof Request;
  const url = typeof input === 'string' ? input : isRequestObject ? input.url : String(input);
  const method = (init?.method ?? (isRequestObject ? input.method : 'GET')).toUpperCase();
  const result: { body?: string; method: string; url: string } = { body: undefined, method, url };
  if (typeof init?.body === 'string') {
    result.body = init.body;
  }
  return result;
};
